<template>
  <div class="container" style="height: 100%">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div
      class="content c-top"
      style="height: calc(100% - 60px); position: relative"
    >
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-table
        :data="tableData"
        :header-cell-style="{
          background: '#F5F6FA',
          textAlign: 'left',
          color: '#303033',
        }"
        style="width: 100%"
        :toggleRowExpansion="{ expanded: true }"
        ref="theTable"
        :row-style="{ height: '100px' }"
      >
        <el-table-column label="佣金类型" prop="type" align="center" width="300">
          <template slot="header">
            <div style="display: flex">
              <div style="line-height: 30px">佣金类型</div>
            </div>
          </template>
          <template slot-scope="props">
            <div style="text-align: left;">{{ props.row.type }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="普通商品比例"
          prop="amount"
          min-width="50"
          align="left"
        >
          <template slot="header">
            <div style="display: flex">
              <div style="line-height: 30px">普通商品比例</div>
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  '设置的总比例（自返佣金+一级佣金）建议低于服务商比例' +
                  tableData[0].normalPlatformProportion +
                  '%'
                "
                placement="top"
              >
                <div style="padding-top: 6px; margin-left: 4px">
                  <img
                    style="width: 18px; height: 18px"
                    src="../../../assets/icon/icon_qipao.png"
                  />
                </div>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="props">
            <el-input
              placeholder="请输入佣金比例"
              size="small"
              style="width: 80%"
              v-model="props.row.normalCommissionProportion"
            >
              <div slot="suffix" style="margin-top: 4px">%</div>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="说明" prop="remark" min-width="50" align="left">
          <template slot="header">
            <div style="display: flex">
              <div style="line-height: 30px">说明</div>
            </div>
          </template>
          <template slot-scope="props">
            <div style="text-align: left">{{ props.row.remark }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom-box">
        <el-button
          type="primary"
          size="medium"
          style="width: 184px"
          @click="updateCommissionConfig"
          >确认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
export default {
  watch: {
  },
  components: {
    breadcrumbTop,
    breadcrumbSearch
  },
  data () {
    return {
      searchList: {
        list: [
          { title: '佣金设置', path: '', type: '0' }
        ]
      },
      dataList: {
        list: [
          { title: '系统管理', path: '', type: '0' },
          { title: '佣金设置', path: '', type: '1' }
        ]
      },
      tableData: [
        {
          type:'自返佣金',
          normalCommissionProportion: '',
          normalPlatformProportion: '',
          remark: '平台用户在平台下单购买商品，获得对应类型的商品比例佣金；'
        },
        {
          type:'一级佣金',
          normalCommissionProportion: '',
          normalPlatformProportion: '',
          remark: '平台用户在平台下单购买商品，用户绑定的上级用户获得对应类型的商品比例佣金；'
        }
      ],
      dialogUser: false,
      loading: false,
      fileListImg: [], // 上传图片
      imageUrl: '',
      input1: '', //
      parArray: [], //
      lastTime: 0
      // tableData: [],
    }
  },
  mounted () {
  },
  created () {
    this.getCommissionConfig()
  },
  methods: {
    updateCommissionConfig () {
      console.log(this.tableData[0].normalCommissionProportion)
      if (this.tableData[0].normalCommissionProportion == '' || this.tableData[0].normalCommissionProportion == null) {

        this.$message.warning('请输入自返佣金比例')
        return
      }
      if (this.tableData[1].normalCommissionProportion == '' || this.tableData[1].normalCommissionProportion == null) {

        this.$message.warning('请输入一级佣金比例')
        return
      }
      let data = {
        normalCommissionProportion: this.tableData[0].normalCommissionProportion,
        firstNormalCommProp: this.tableData[1].normalCommissionProportion
      }
      this.axios.post('/users/updateCommissionConfig', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('保存成功')
            this.getCommissionConfig()
          }
        })
    },
    getCommissionConfig () {
      this.axios.get('/users/getCommissionConfig')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.tableData[0].normalCommissionProportion = res.data.normalCommissionProportion;
            this.tableData[0].normalPlatformProportion = res.data.normalPlatformProportion
            this.tableData[1].normalCommissionProportion = res.data.firstNormalCommProp;
          }
        })
    },

  }
}
</script>
<style scoped lang="scss">
.el-table td,
.el-table th[data-v-372de25b] {
  text-align: left !important;
}
::v-deep.el-table td {
  text-align: left !important;
}
.bottom-box {
  width: 100%;
  height: 88px;
  border-top: 1px solid #ebebfa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
